export default __webpack_public_path__ + "static/media/Frame_Moving.d74cfcd5.svg";